import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { messages } from './store/messages.module';
import { account } from './store/account.module';
import { tools } from './store/tools.module';
import { tasks } from './store/tasks.module';
import { places } from './store/places.module';
import { people } from './store/people.module';
import { operations } from './store/operations.module';
import { settings } from './store/settings.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {
    alert,
    messages,
    account,
    tools,
    tasks,
    places,
    people,
    operations,
    settings
  }
});